import { Entity } from '@inter-ikea-core/core';
import { CoreApi, Product } from '@inter-ikea-storageone/range';

export const getProductFromEntity = (entity: Entity, products: Product[], coreApi: CoreApi) => {
  const productRef = coreApi.entities.getProductRef(entity);

  if (!productRef) return null;

  return products.find(product => product.coreProductId === productRef);
};
